
<div v-show="show">
  <div
    v-show="openBrowserTips"
    @click="openBrowserTips = !openBrowserTips"
    class="open-browser-tips"
  >
    <img class="tips" src="@/assets/evokeapp/open-browser-tips.png" />
  </div>
  <a class="open-app-popup" v-if="supportUniversal" :href="universalLink">
  </a>
  <div v-else class="open-app-popup" @click="openDialog(true)"></div>
</div>
